import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Title from './Title';

interface DashCardProps{
  title:any,
  mainText:string,
  smallText:string,
  buttonText:string,
  buttonOnClick:(e:any)=>void
}

export default function DashCard(props:DashCardProps) {
  return (
    <React.Fragment>
      <Title>{props.title}</Title>
      <Typography component="p" variant="h2">
        {props.mainText}
      </Typography>
      <Typography color="textSecondary" style={{flex:1}}>
        {props.smallText}
      </Typography>
      <div >
        <Link color="primary" href="#" onClick={props.buttonOnClick}>
          {props.buttonText}
        </Link>
      </div>
    </React.Fragment>
  );
}